var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"back-link",attrs:{"to":{ name: _vm.route }}},[_c('CoreIcon',{attrs:{"icon":"arrow-left"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }